@let favouritesGridNavigation = favouritesGridNavigation$ | async;
@if (favouritesGridNavigation && favouritesGridNavigation.length > 0) {
    <ms-widget-header [title]="title" [titleIcon]="'sports-favourites'" [fallbackIcon]="'sports-favourites'" />
    @if (showPrimaryNavAsPill) {
        <ms-widget-pill class="menu-disabled" [pills]="favouritesGridNavigation" />
    } @else {
        <ms-widget-tab-bar class="menu-disabled" [tabs]="favouritesGridNavigation" />
    }
    <ms-component-loader />
}
